module.exports = __webpack_public_path__ + "static/media/module-audit.dd0b8222.svg";